import { Role } from '@wit-support/admin-contracts';
/** Canonical role list — sourced from the admin-contracts Zod enum. */
export const ROLES = Role.options;
export const ROLE_HUE = {
    owner: 'crimson',
    supervisor: 'violet',
    member: 'blue',
    viewer: 'slate',
    marketing: 'amber',
};
//# sourceMappingURL=roles.js.map